<template>
  <div class="lista-materia-prima-wrapper px-2 py-4">
    <!-- Mensaje de alerta solo si hay pendientes -->
    <div v-if="!mostrarConMateriaPrima" class="alert alert-warning d-flex align-items-center gap-3 mb-3" role="alert">
      <font-awesome-icon icon="triangle-exclamation" class="text-warning" size="2x" />
      <div>
        <h5 class="mb-1 fw-bold">¡Hay Biomasa Pendiente!</h5>
        <p class="mb-0 small">
          Debés procesar esta biomasa para continuar el flujo de producción.
        </p>
      </div>
    </div>

    <!-- Botones de vista -->
    <div class="mb-4 d-flex gap-2 flex-wrap">
      <button
        class="btn"
        :class="!mostrarConMateriaPrima ? 'btn-success' : 'btn-outline-success'"
        @click="mostrarConMateriaPrima = false">
        <font-awesome-icon icon="leaf" class="me-2" />
        Ver Biomasa Pendiente
      </button>

      <button
        class="btn"
        :class="mostrarConMateriaPrima ? 'btn-primary' : 'btn-outline-primary'"
        @click="mostrarConMateriaPrima = true">
        <font-awesome-icon icon="flask" class="me-2" />
        Ver Biomasa Procesada
      </button>
    </div>

    <!-- Componente dinámico -->
    <BiomasaPendiente v-if="!mostrarConMateriaPrima" />
    <BiomasaConMateriaPrima v-else />
  </div>
</template>

<script>
import BiomasaPendiente from './BiomasaPendiente.vue';
import BiomasaConMateriaPrima from './BiomasaConMateriaPrima.vue';

export default {
  name: 'ListaMateriaPrimaWrapper',
  components: {
    BiomasaPendiente,
    BiomasaConMateriaPrima
  },
  data() {
    return {
      mostrarConMateriaPrima: false
    };
  }
};
</script>

<style scoped>
.lista-materia-prima-wrapper {
  max-width: 100%;
}

.alert {
  border-radius: 8px;
  font-size: 0.95rem;
}

.btn {
  min-width: 220px;
}
</style>
